module.exports = __webpack_public_path__ + "img/arrow_twin.c2bca620.svg";